import React from "react"
import { StaticImage } from "gatsby-plugin-image"

import { SectionHeader, MainWrapper } from "components"
import { AboutWrapper, AboutContent } from "./styles"
import background from "../../images/back.png"

export const About = () => {
  return (
    <AboutWrapper id="about" background={background}>
      <MainWrapper>
        <SectionHeader title="About" />
        <AboutContent>
          <div className="left">
            <p data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
              We have been serving authentic Mexican specialties prepared from
              family recipes since 1961. We have one convenient loactions in
              Burbank. Our generous portions and great tasting margaritas are
              sure to leave you satisfied!
            </p>
            <ul>
              <li
                data-sal="slide-up"
                data-sal-delay="300"
                data-sal-easing="ease"
              >
                <div>
                  <StaticImage
                    src="../../images/online-order.png"
                    alt="Online Order"
                    imgStyle={{ padding: "7px" }}
                    height={30}
                    width={30}
                  />
                </div>
                <span>Order Take-Out Online</span>
              </li>
              <li
                data-sal="slide-up"
                data-sal-delay="350"
                data-sal-easing="ease"
              >
                <div>
                  <StaticImage
                    src="../../images/cuisine.png"
                    alt="Cuisines"
                    imgStyle={{ padding: "7px" }}
                    height={30}
                    width={30}
                  />
                </div>
                <span>Cuisines</span>
              </li>
              <li
                data-sal="slide-up"
                data-sal-delay="400"
                data-sal-easing="ease"
              >
                <div>
                  <StaticImage
                    src="../../images/serving-dish.png"
                    alt="Serving"
                    imgStyle={{ padding: "7px" }}
                    height={30}
                    width={30}
                  />
                </div>
                <span>Serving</span>
              </li>
            </ul>
          </div>
          <div data-sal="slide-up" data-sal-delay="300" data-sal-easing="ease">
            <StaticImage
              imgStyle={{ borderRadius: "20px" }}
              src="../../images/about.jpeg"
              alt="Barragans Restaurant"
            />
          </div>
        </AboutContent>
      </MainWrapper>
    </AboutWrapper>
  )
}
